import clsx from 'clsx'
import React, { useEffect } from 'react'

type CloseReason = 'outsideClick' | 'escapeKey' | 'closeButton'

export interface ModalCloseEvent {
  detail?: {
    reason?: CloseReason
  }
}

interface ModalProps {
  open: boolean
  children: React.ReactNode
  onClose: (event: ModalCloseEvent) => void
  disableOutsideClick?: boolean
  size?: 's' | 'm' | 'l'
  className?: string
}

export const Modal = ({ open, children, onClose, disableOutsideClick, size = 'm', className }: ModalProps) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
      document.body.style.paddingRight = '15px'
    } else {
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }

    return () => {
      document.body.style.overflow = ''
      document.body.style.paddingRight = ''
    }
  }, [open])
  if (!open) return null

  const triggerClose = (reason?: CloseReason) => {
    onClose?.({ detail: { reason } })
  }

  const handleOutsideClick = () => {
    if (!disableOutsideClick) {
      triggerClose('outsideClick')
    }
  }

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 overflow-hidden"
      onClick={handleOutsideClick}
    >
      <div
        className={clsx(
          'bg-white rounded-xl w-full max-h-[90vh] flex flex-col overflow-y-auto modal-scroll relative',
          {
            'max-w-[568px]': size === 's',
            'max-w-[762px]': size === 'm',
            'max-w-[1220px]': size === 'l',
          },
          className,
        )}
        onClick={e => e.stopPropagation()}
      >
        <>{children}</>
      </div>
    </div>
  )
}
